import moment from "moment";
import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import { FiCopy } from "react-icons/fi";
import { TransactionContext } from "../../pages/Transactions/Transaction";
import { copyValue } from "../../plugins/utils";
import Divider from "../Divider/Divider";
import "./transaction.scss";

const TransactionDetails = () => {
  const {
    state: {
      paymentStatus,
      channel,
      merchantId,
      transactionCategory,
      terminalType,
      amount,
      terminalId,
      referenceID,
      businessName,
      wayaposFees,
      date,
      billerName,
      productName,
      customerIdentifier,
      sourceAccount,
      sourceAccountName,
      destinationAccount,
      thirdPartyReference,
    },
  } = useContext(TransactionContext);

  const getAmount = () => {
    if (amount !== "") {
      let res = parseFloat(amount);
      return res / 100;
    } else {
      return "0.00";
    }
  };
  const statusButton = () => {
    if (paymentStatus) {
      switch (paymentStatus.toLowerCase()) {
        case "successful":
          return "button-success";
        case "failed":
          return "request-button";
        default:
          return "request-button";
      }
    }
  };
  return (
    <Col className="tran-details ms-2">
      <div className="tran-padding">
        <h4 className="text-semi-dark fs-14">Amount</h4>
        <div className="d-flex justify-content-between mt-20">
          <h4 className="fs-18 fw-700 text--darker">NGN {getAmount()}</h4>
          {paymentStatus && (
            <span className={`${statusButton()} br-10 py-1`}>
              {paymentStatus}
            </span>
          )}
        </div>

        {referenceID && (
          <>
            <div className="d-flex justify-content-between mt-40 mb-15">
              <h4 className="text-darker fs-12">Reference ID</h4>
              <h4 className="text-darker fs-12 fw-700">
                {referenceID}
                {""}
                <span
                  className="ms-2 fs-12 text-muted"
                  onClick={() => copyValue(referenceID)}
                >
                  <FiCopy />
                </span>
              </h4>
            </div>
            <Divider />
          </>
        )}

        {merchantId && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Merchant ID</h4>
              <h4 className="text-darker fs-12 fw-700">{merchantId}</h4>
            </div>
            <Divider />
          </>
        )}

        {terminalId && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Terminal ID</h4>
              <h4 className="text-darker fs-12 fw-700">
                {terminalId}{" "}
                <span
                  className="ms-2 fs-12 text-muted"
                  onClick={() => copyValue(terminalId)}
                >
                  <FiCopy />
                </span>
              </h4>
            </div>
            <Divider />
          </>
        )}

        {terminalType && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Terminal Device Name</h4>
              <h4 className="text-darker fs-12 fw-700">{terminalType}</h4>
            </div>
            <Divider />
          </>
        )}

        {businessName && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Business Name</h4>
              <h4 className="text-darker fs-12 fw-700">{businessName}</h4>
            </div>
            <Divider />
          </>
        )}

        {transactionCategory && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Transaction Category</h4>
              <h4 className="text-darker fs-12 fw-700">
                {transactionCategory}
              </h4>
            </div>
            <Divider />
          </>
        )}

        {channel && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Channel</h4>
              <h4 className="text-darker fs-12 fw-700">{channel}</h4>
            </div>
            <Divider />
          </>
        )}

        {wayaposFees && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Wayapos Fees</h4>
              <h4 className="text-darker fs-12 fw-700">{wayaposFees}</h4>
            </div>
            <Divider />
          </>
        )}

        {date && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Date Paid</h4>
              <h4 className="text-darker fs-12 fw-700">
                {moment(new Date(date)).format("D/MM/YYYY")}
              </h4>
            </div>
            <Divider />
          </>
        )}

        {billerName && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Biller Name</h4>
              <h4 className="text-darker fs-12 fw-700">{billerName}</h4>
            </div>
            <Divider />
          </>
        )}
        {productName && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Product Name</h4>
              <h4 className="text-darker fs-12 fw-700">{productName}</h4>
            </div>
            <Divider />
          </>
        )}
        {customerIdentifier && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Customer Identifier</h4>
              <h4 className="text-darker fs-12 fw-700">{customerIdentifier}</h4>
            </div>
            <Divider />
          </>
        )}
        {sourceAccount && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Source Account</h4>
              <h4 className="text-darker fs-12 fw-700">{sourceAccount}</h4>
            </div>
            <Divider />
          </>
        )}
        {sourceAccountName && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Source Account Name</h4>
              <h4 className="text-darker fs-12 fw-700">{sourceAccountName}</h4>
            </div>
            <Divider />
          </>
        )}
        {destinationAccount && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Destination Account</h4>
              <h4 className="text-darker fs-12 fw-700">{destinationAccount}</h4>
            </div>
            <Divider />
          </>
        )}
        {thirdPartyReference && (
          <>
            <div className="d-flex justify-content-between mt-20 mb-15">
              <h4 className="text-darker fs-12">Third Party Reference</h4>
              <h4 className="text-darker fs-12 fw-700">{thirdPartyReference}</h4>
            </div>
            <Divider />
          </>
        )}
      </div>
    </Col>
  );
};

export default TransactionDetails;
